/**
 * Design-direction generation contract. The agent sends intent only (page type +
 * exemplar picks); the server assembles the prompt from the project-context
 * file and the corpus description verbatim, so descriptions can never be
 * trimmed or mean-reverted by the model in between.
 */
import { z } from "zod";

export const designDirectionRequestSchema = z
  .object({
    // Corpus page type (e.g. "home-landing"); validated against the corpus at runtime.
    pageType: z.string(),
    // Exactly three exemplar ids from three different aesthetic families.
    exemplarIds: z.array(z.string()).length(3),
    // Used only when the project-context file has no identity yet (fresh
    // greenfield project); receipts mark these fields as agent-supplied.
    brandFallback: z.object({ name: z.string(), sells: z.string() }).nullish(),
  })
  .describe("DesignDirectionRequest");

export const designDirectionSchema = z
  .object({
    exemplarId: z.string(),
    family: z.string(),
    jobId: z.string(),
    // Hash of the exact prompt sent — the auditable receipt.
    promptSha: z.string(),
  })
  .describe("DesignDirection");

export const designDirectionSetSchema = z
  .object({
    directions: z.array(designDirectionSchema).length(3),
    // Which project-context fields entered the preamble — every claim cites its source.
    factsUsed: z.array(z.object({ field: z.string(), value: z.string() })),
    model: z.string(),
  })
  .describe("DesignDirectionSet");
